<template>
  <div class="tour-card">
    <ModalTour
      v-if="showFirstModal"
      :modal-data="firstDataModal"
      @close-modal="closeFirstModal"
      @agreed="openOnboarding"
    />
    <ModalTour
      v-if="showLastModal"
      :modal-data="lastDataModal"
      @close-modal="closeLastModal"
      @agreed="closeLastModal"
    />
    <div
      class="onboarding-overlay"
    />
    <v-tour
      name="myTour"
      :steps="steps"
      :callbacks="tourCallbacks"
    >
      <template slot-scope="tour">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :class="tour.steps[tour.currentStep].params.placement"
        >
          <div
            v-if="tour.steps[tour.currentStep].title"
            slot="header"
          >
            <div class="tour-modal__header">
              <div class="tour-modal__header__title">
                <span>
                  {{ tour.steps[tour.currentStep].title }}
                </span>
              </div>
              <div
                class="btn tour-modal__header__close"
                @click="tour.skip"
              >
                <span>&times;</span>
              </div>
            </div>
          </div>
          <div slot="content">
            <div class="tour-modal__content">
              <span v-html="sanitizeText(tour.steps[tour.currentStep].content)" />
            </div>
          </div>

          <div slot="actions">
            <div class="tour-modal__actions">
              <div class="tour-modal__actions--steps">
                <span>{{ step }}/{{ finalStep }} </span>
              </div>
              <div class="tour-modal__actions--buttons">
                <button
                  v-if="tour.steps[tour.currentStep].isLastInTour"
                  class="btn tour-modal__actions__btn--primary"
                  @click="finishTour"
                >
                  Próximo
                </button>
                <button
                  v-else-if="tour.isLast"
                  class="btn tour-modal__actions__btn--primary"
                  @click="finishTour"
                >
                  Próximo
                </button>
                <button
                  v-else
                  class="btn tour-modal__actions__btn--primary"
                  @click="tour.nextStep"
                >
                  Próximo
                </button>
              </div>
            </div>
          </div>
        </v-step>
      </template>
    </v-tour>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import sanitizeText from '@/mixins/dompurifyMixin.js';
import ModalTour from '@/components/onboardingComponents/ModalTour.vue';
export default {
  name: 'TourCard',

  components: {
    ModalTour
  },

  mixins: [ sanitizeText ],

   data () {
    return {
      tourCallbacks: {
        onNextStep: this.nextStep,
        onStop: this.stopTour,
      },
      showFirstModal: false,
      showLastModal: false,
      steps: [],
      changeFinishedPage: false,
      firstDataModal: {
        title: 'Quando abrir uma reclamação?',
        text: 'Abra uma reclamação se você tiver uma relação de consumo comprovada e houver infração ao Código de Defesa do Consumidor ou outra legislação (ex.: cobrança indevida, defeitos em produtos, prazos não cumpridos, problemas com SAC, etc).',
        buttonText: 'Iniciar tour'
      },
      lastDataModal: {
        title: 'Viu como é fácil?',
        text: 'Agora você está pronto para registrar e acompanhar suas reclamações com facilidade!',
        buttonText: 'Concluir'
      }
    };
  },

  computed: {
    ...mapGetters([
      'tourGuide',
      'finishedTourPage',
      'showOnboarding',
      'step',
      'finalStep'
    ]),
  },

  mounted() {
    this.clearTourGuide();
    this.$root.$on('beginTour', () => {
      this.beginTour();
    });
  },

  beforeDestroy() {
    this.$root.$off('beginTour');
  },

  methods: {
    ...mapActions([
      'initializeTourGuide',
      'finalizeTourGuide',
      'incrementStep',
      'incrementTourIndex',
      'getTourGuide',
      'clearTourGuide',
      'setSkippedTour',
    ]),

    startTour() {
      if(this.showOnboarding) {
        this.$tours.myTour.start();
      }
    },

    beginTour() {
      this.initializeTourGuide();
      this.getTourGuide().then((tour) => {
        this.steps = tour;
      });
      window.scrollTo(0, 0);
      this.showFirstModal = true;
    },

    closeFirstModal() {
      this.finalizeTourGuide();
      this.showFirstModal = false;
    },

    openOnboarding() {
      document.querySelector('.onboarding-overlay').classList.add('onboarding-overlay--show');
      this.startTour();
      this.showFirstModal = false;
    },

    closeLastModal() {
      this.finalizeTourGuide();
      this.showLastModal = false;
    },

    nextStep() {
      this.incrementStep();
    },

    stopTour() {
      if(this.changeFinishedPage) {
        this.changeFinishedPage = false;
      } else {
        window.scrollTo(0, 0);
        document.querySelector('.onboarding-overlay').classList.remove('onboarding-overlay--show');
        this.finalizeTourGuide();
        if(this.$router.currentRoute.name !== 'OnlineComplaint') {
          this.$router.replace({ name: 'OnlineComplaint', query: {} });
        }
      }
    },

    finishTour() {
      let currentStep = this.$tours.myTour.currentStep;

      if(this.steps[currentStep].isLastInTour) {
        window.scrollTo(0, 0);
        this.showLastModal = true;
        this.$tours.myTour.stop();
      } else {
        this.incrementTourIndex();
        this.incrementStep();
        this.changeFinishedPage = true;
        this.$tours.myTour.stop();
        if(this.steps[currentStep].redirect) {
          if(this.steps[currentStep].redirect === 'NextStep') {
            this.$root.$emit('complaintNextPage');
            this.startTour();
          } else if (this.steps[currentStep].redirect === 'SkipThreeSteps') {
            this.$root.$emit('complaintSkipThreeSteps');
            this.startTour();
          } else {
            this.$router.replace({ name: this.steps[currentStep].redirect, query: {} });
          }
        }

        this.getTourGuide().then((tour) => {
          this.steps = tour;
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.v-step {
  background: $onboarding-bg;
  border-radius: 5px;
  padding: 1rem;
  width: 90%;
  color: $gray-60;

  @include screen(phone-up) {
    width: 100%;
  }

  &.top {
    margin-bottom: 1rem !important;
  }

  &.right {
    margin-left: 1rem !important;
  }

  &.bottom {
    margin-top: 1rem !important;
  }

  &.left {
    margin-right: 1rem !important;
  }

  .btn {
    box-shadow: none;
  }
}

.onboarding-overlay {
  background: black;
  opacity: 0.4;
  position: fixed;
  z-index: 14;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;

  &--show {
    display: block;
  }
}

.tour-modal {
  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    text-align: left;

    &__title {
      @include text-l(1, 2);

      padding: 0.75rem 0;

      @include screen(tablet-big-up) {
        @include text-xl(2);
      }
    }

    &__close {
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: transparent;
      align-items: center;
      justify-content: center;
      display: flex;
      color: $gray-50;
      font-weight: 300;
      font-size: $text-5xl;
    }
  }

  &__content {
    display: flex;
    font-size: $text-sm;
    font-weight: 400;
    margin-bottom: 1rem;
    text-align: left;
    width: 100%;
  }

  &__actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &__btn {
      &--primary {
        padding: 0.5rem;
        color: $white;
        background: $primary;
      }

      &--secondary {
        color: $primary;
        background: transparent;
      }
    }

    &--buttons {
      display: flex;
      flex-direction: row;
      gap: 1rem;

      .btn {
        padding: 0.75rem 1.5rem;
        border-radius: $radius-lg;
        font-size: $text-sm;
        font-family: $montserrat-semibold;
      }
    }

    &--steps {
      color: $primary;
    }
  }
}
</style>
